module.exports = __webpack_public_path__ + "static/img/Oryn-Keeley.c044aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Oryn-Keeley.jpg
// module id = FoZi
// module chunks = 0